module.exports = __webpack_public_path__ + "img/ethos.5f5b3e25.svg";